import type { HttpTransport } from "@common/api/transport";

export type FrostZoneParams = {
  latitude?: number;
  longitude?: number;
  zipcode?: string;
};

export type FrostZoneResponse = Record<
  "lastHardFrost" | "lastFrost" | "firstHardFrost" | "firstFrost" | "growingZone",
  string | undefined
>;

type GeoLookup = {
  value: string;
  zipcode: string;
  country: string;
  coordinates: { latitude: number; longitude: number };
};

export const createSettingsApi = (http: HttpTransport) => ({
  fetchFrostZones: ({ latitude, longitude, zipcode }: FrostZoneParams) =>
    http.get<FrostZoneResponse>("/settings/calculate_settings", {
      queryParams: { latitude, longitude, zipcode }
    }),

  fetchGeoLookup: (query: string) =>
    http.get<GeoLookup[]>(`/settings/geo_lookup?query=${query}`)
});
